import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Transferir", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_25 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_selecionar_marcador_movimento_financeiro = _resolveComponent("selecionar-marcador-movimento-financeiro")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    centered: "",
    "wrap-class-name": _ctx.telaBase.apresentarEmpresas?'scroll-modal ss-modal-financeiro':'ss-modal-financeiro',
    maskClosable: false
  }, {
    title: _withCtx(() => [
      _createTextVNode("Transferência entre Contas")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmarTransferência && _ctx.confirmarTransferência(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_card, { titulo: "DADOS DA TRANSFERÊNCIA" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_form_item, {
                    label: "Data",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_data, {
                        horaMinutoSegundo: true,
                        dataSelecionada: _ctx.state.dataTransferencia,
                        "onUpdate:dataSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dataTransferencia) = $event))
                      }, null, 8, ["dataSelecionada"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_form_item, {
                    label: "N.Identificação",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.movimentoSaida.identificadorMovimento) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.movimentoSaida.identificadorMovimento]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_form_item, {
                    label: "Valor",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        monetario: true,
                        quantidadeCasasDecimais: 2,
                        valor: _ctx.state.movimentoSaida.valor,
                        "onUpdate:valor": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.movimentoSaida.valor) = $event)),
                          _cache[4] || (_cache[4] = ($event: any) => (_ctx.alterarSaldoFinal()))
                        ]
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_form_item, {
                    label: "Descrição",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.movimentoSaida.descricao) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.movimentoSaida.descricao]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_form_item, {
                    label: "Conciliado",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_sim_nao, {
                        radioButton: true,
                        valor: _ctx.state.movimentoSaida.conciliado,
                        "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.movimentoSaida.conciliado) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo de Documento",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_documento_financeiro, {
                        codigoSelecionado: _ctx.state.movimentoSaida.codigoTipoDocumentoFinanceiro,
                        "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.movimentoSaida.codigoTipoDocumentoFinanceiro) = $event)),
                        empresas: [_ctx.state.movimentoSaida.codigoEmpresa],
                        movimentacaoSaidaPagamentos: true,
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.verificaEstrategiaTipoDocumentoBaseSaida()))
                      }, null, 8, ["codigoSelecionado", "empresas"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_form_item, {
                    label: "Categoria",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_categoria_plano_conta, {
                        codigoSelecionado: _ctx.state.movimentoSaida.codigoPlanoContaCategoria,
                        "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.movimentoSaida.codigoPlanoContaCategoria) = $event)),
                        tipoPlanoConta: _ctx.ETipoPlanoConta.Financeiro,
                        empresas: [_ctx.state.movimentoSaida.codigoEmpresa],
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.movimentoEntrada.codigoPlanoContaCategoria = _ctx.state.movimentoSaida.codigoPlanoContaCategoria))
                      }, null, 8, ["codigoSelecionado", "tipoPlanoConta", "empresas"])
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [_vShow, (!_ctx.telaBase.apresentarEmpresas || !_ctx.state.definirTipoDocumentoEntrada)]
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_a_form_item, {
                    label: "Marcadores",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_marcador_movimento_financeiro, {
                        marcadoresSelecionados: _ctx.state.marcadores,
                        "onUpdate:marcadoresSelecionados": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                        empresas: [_ctx.state.movimentoSaida.codigoEmpresa]
                      }, null, 8, ["marcadoresSelecionados", "empresas"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_card, { titulo: "CONTA DE ORIGEM" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_form_item, {
                    label: "Empresa",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_empresa, {
                        codigoSelecionado: _ctx.state.movimentoSaida.codigoEmpresa,
                        "onUpdate:codigoSelecionado": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.movimentoSaida.codigoEmpresa) = $event)),
                        empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.redefinirTipoDocumentoCategoriaOrigem()))
                      }, null, 8, ["codigoSelecionado", "empresasEspecificas"])
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [_vShow, _ctx.telaBase.apresentarEmpresas]
              ]),
              (_openBlock(), _createElementBlock("div", {
                key: _ctx.state.movimentoSaida.codigoConta,
                class: "ant-row"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.UtilitarioGeral.validaCodigo(_ctx.state.movimentoSaida.codigoConta)?'ant-col ant-col-xs-24 ant-col-xl-18':'ant-col ant-col-xs-24 ant-col-xl-24')
                }, [
                  _createVNode(_component_selecionar_conta, {
                    codigoSelecionado: _ctx.state.movimentoSaida.codigoConta,
                    "onUpdate:codigoSelecionado": [
                      _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.movimentoSaida.codigoConta) = $event)),
                      _cache[15] || (_cache[15] = ($event: any) => (_ctx.alterarContaOrigem()))
                    ],
                    empresas: [_ctx.state.movimentoSaida.codigoEmpresa],
                    omitirContas: [_ctx.state.movimentoEntrada.codigoConta],
                    required: true
                  }, null, 8, ["codigoSelecionado", "empresas", "omitirContas"])
                ], 2),
                _withDirectives(_createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_spin, {
                    spinning: _ctx.state.carregandoSaldoOrigem
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "Saldo após a Transferência",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            monetario: true,
                            quantidadeCasasDecimais: 2,
                            permitirValorNegativo: true,
                            valor: (_ctx.state.saldoContaOrigem - _ctx.state.movimentoSaida.valor),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["spinning"])
                ], 512), [
                  [_vShow, _ctx.UtilitarioGeral.validaCodigo(_ctx.state.movimentoSaida.codigoConta)]
                ])
              ])),
              (((_ctx.state.movimentoSaida.codigoEmpresa !== _ctx.state.movimentoEntrada.codigoEmpresa) || _ctx.state.definirTipoDocumentoEntrada))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Documento",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_documento_financeiro, {
                            codigoSelecionado: _ctx.state.movimentoSaida.codigoTipoDocumentoFinanceiro,
                            "onUpdate:codigoSelecionado": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.movimentoSaida.codigoTipoDocumentoFinanceiro) = $event)),
                            empresas: [_ctx.state.movimentoSaida.codigoEmpresa],
                            movimentacaoSaidaPagamentos: true
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_a_form_item, {
                        label: "Categoria",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_categoria_plano_conta, {
                            codigoSelecionado: _ctx.state.movimentoSaida.codigoPlanoContaCategoria,
                            "onUpdate:codigoSelecionado": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.movimentoSaida.codigoPlanoContaCategoria) = $event)),
                            tipoPlanoConta: _ctx.ETipoPlanoConta.Financeiro,
                            empresas: [_ctx.state.movimentoSaida.codigoEmpresa]
                          }, null, 8, ["codigoSelecionado", "tipoPlanoConta", "empresas"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_card, { titulo: "CONTA DE DESTINO" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_a_form_item, {
                    label: "Empresa",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_empresa, {
                        codigoSelecionado: _ctx.state.movimentoEntrada.codigoEmpresa,
                        "onUpdate:codigoSelecionado": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.movimentoEntrada.codigoEmpresa) = $event)),
                        empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                        onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.redefinirTipoDocumentoCategoriaDestino()))
                      }, null, 8, ["codigoSelecionado", "empresasEspecificas"])
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [_vShow, _ctx.telaBase.apresentarEmpresas]
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(), _createElementBlock("div", {
                  key: _ctx.state.movimentoEntrada.codigoConta,
                  class: _normalizeClass(_ctx.UtilitarioGeral.validaCodigo(_ctx.state.movimentoEntrada.codigoConta)?'ant-col ant-col-xs-24 ant-col-xl-18':'ant-col ant-col-xs-24 ant-col-xl-24')
                }, [
                  _createVNode(_component_selecionar_conta, {
                    codigoSelecionado: _ctx.state.movimentoEntrada.codigoConta,
                    "onUpdate:codigoSelecionado": [
                      _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.movimentoEntrada.codigoConta) = $event)),
                      _cache[21] || (_cache[21] = ($event: any) => (_ctx.alterarContaDestino()))
                    ],
                    empresas: [_ctx.state.movimentoEntrada.codigoEmpresa],
                    omitirContas: [_ctx.state.movimentoSaida.codigoConta],
                    required: true
                  }, null, 8, ["codigoSelecionado", "empresas", "omitirContas"])
                ], 2)),
                _withDirectives(_createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_a_spin, {
                    spinning: _ctx.state.carregandoSaldoDestino
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "Saldo após a Transferência",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            monetario: true,
                            quantidadeCasasDecimais: 2,
                            permitirValorNegativo: true,
                            valor: _ctx.state.saldoContaDestino + _ctx.state.movimentoEntrada.valor,
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["spinning"])
                ], 512), [
                  [_vShow, _ctx.UtilitarioGeral.validaCodigo(_ctx.state.movimentoEntrada.codigoConta)]
                ])
              ]),
              (((_ctx.state.movimentoSaida.codigoEmpresa !== _ctx.state.movimentoEntrada.codigoEmpresa) || _ctx.state.definirTipoDocumentoEntrada))
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Documento",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_documento_financeiro, {
                            codigoSelecionado: _ctx.state.movimentoEntrada.codigoTipoDocumentoFinanceiro,
                            "onUpdate:codigoSelecionado": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.movimentoEntrada.codigoTipoDocumentoFinanceiro) = $event)),
                            empresas: [_ctx.state.movimentoEntrada.codigoEmpresa],
                            movimentacaoEntradaRecebimentos: true
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_a_form_item, {
                        label: "Categoria",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_categoria_plano_conta, {
                            codigoSelecionado: _ctx.state.movimentoEntrada.codigoPlanoContaCategoria,
                            "onUpdate:codigoSelecionado": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.movimentoEntrada.codigoPlanoContaCategoria) = $event)),
                            tipoPlanoConta: _ctx.ETipoPlanoConta.Financeiro,
                            empresas: [_ctx.state.movimentoEntrada.codigoEmpresa]
                          }, null, 8, ["codigoSelecionado", "tipoPlanoConta", "empresas"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}